import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getStatus } from "../../redux/selector";

const useStyles = makeStyles({
    redText: {
        color: "rgb(255, 0, 0)",
    },
    boldText: {
        fontWeight: "bold",
    },
    ContentLineHight: {
        lineHeight: "23px",
    },
    mb5: {
        marginBottom: "5px",
    },
});

function Form098EditDialog({ formOpen, onConfirm }) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const formStatus = useSelector(getStatus());

    return (
        <React.Fragment>
            <Dialog
                // onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                open={formOpen}
            >
                <DialogTitle id="simple-dialog-title">
                    {t("Form098.editDialog.title")}
                </DialogTitle>
                <DialogContent className={classes.ContentLineHight}>
                    <Typography>
                        {formStatus === 1
                            ? t("Form098.editDialog.note1")
                            : t("Form098.editDialog.note2")}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={onConfirm} color="success">
                        <b>{t("common.portal.confirm")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default Form098EditDialog;
